import { Box, Stack, Typography } from "@mui/material";
import { allColors } from "../../constants";

const ReviewChipCard = ({ name, designation, image, selected, onClick }) => {
    return (
        <Stack
            direction="row"
            alignItems="center"
            gap={1.25}
            px={1.1}
            py={0.75}
            sx={{
                border: "1px solid rgba(255, 255, 255, 0.9)",
                borderRadius: "999px",
                minWidth: 150,
                backgroundColor: "transparent",
                cursor: "pointer",
                ...(selected && {
                    backgroundColor: allColors.blueBerry,
                    color: allColors.white,
                    borderColor: allColors.blueBerry,
                    "&:hover": {
                        backgroundColor: allColors.blueBerry,
                        color: allColors.white,
                        borderColor: allColors.blueBerry,
                    },
                }),
            }}
            onClick={onClick}
        >
            <Box
                component={"img"}
                src={image}
                alt={name}
                sx={{
                    width: 34,
                    height: 34,
                    borderRadius: "50%",
                    objectFit: "cover",
                    flexShrink: 0,
                }}
            />
            <Box>
                <Typography
                    variant="body2"
                    color={allColors.white}
                    fontWeight={500}
                    lineHeight={1.1}
                >
                    {name}
                </Typography>
                <Typography
                    fontSize={10}
                    color={allColors.white}
                    sx={{ opacity: 0.9, textTransform: "uppercase", letterSpacing: "0.4px" }}
                >
                    {designation}
                </Typography>
            </Box>
        </Stack>
    )
}

export default ReviewChipCard;